import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  NotFoundPageComponent,
  ForbiddenPageComponent,
  AppInsightsInterceptor,
  LoginComponent,
  AuthCallbackComponent,
  ProfileComponent,
  AccessDeniedComponent
} from 'common';
import { DefaultPageComponent } from './interaction/components/default-page/default-page.component';
import {DataspacesOverviewComponent} from '@app-so/dataspace/components/dataspace-overview/dataspace-overview.component';
import {AuthGuard} from "@app-so/guard/auth.guard";

const routes: Routes = [
  {
    path: '',
    canActivate: [AppInsightsInterceptor, AuthGuard],
    component: DefaultPageComponent,
    pathMatch: 'full'
  },
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'participants',
        loadChildren: './participants/participants.module#ParticipantsModule'
      },
      {
        path: 'users',
        loadChildren: './users/users.module#UsersModule'
      },
      {
        path: 'versions',
        loadChildren: './versions/versions.module#VersionsModule'
      },
      {
        path: 'isharelogo',
        loadChildren: './logo/logo.module#LogoModule'
      }
    ]
  },
  {
    path: 'dataspace',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './dataspace/dataspace.module#DataspaceModule'
      }
    ]
  },
  {
    path: 'trusted',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './trustedlist/trustedlist.module#TrustedlistModule'
      }
    ]
  },
  {
    path: 'transfer',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './transfer/transfer.module#TransferModule'
      }
    ]
  },
  {
    path: 'revoke',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './revoke/revoke.module#RevokeModule'
      }
    ]
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './reports/reports.module#ReportsModule'
      }
    ]
  },
  {
    path: 'scheduler',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './scheduler/scheduler.module#SchedulerModule'
      }
    ]
  },
  {
    path: 'networkHealthCheck',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './networkHealthCheck/networkHealthCheck.module#NetworkHealthCheckModule'
      }
    ]
  },
  {
    path: 'account',
    loadChildren: 'common/account/account.module#AccountModule'
  },
  {
    path: 'account/login',
    component: LoginComponent,
    canActivate: [AppInsightsInterceptor],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AppInsightsInterceptor],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'callback',
    canActivate: [AppInsightsInterceptor],
    component: AuthCallbackComponent
  },
  {
    path: 'access-denied',
    canActivate: [AppInsightsInterceptor],
    component: AccessDeniedComponent
  },
  {
    path: 'forbidden',
    canActivate: [AppInsightsInterceptor],
    component: ForbiddenPageComponent
  },
  { path: '**',canActivate: [AppInsightsInterceptor], redirectTo: '' },
  /*{
    path: '**',
    canActivate: [AppInsightsInterceptor],
    component: NotFoundPageComponent,

  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
